export default "__VITE_PUBLIC_ASSET__05fe6f09__"